import { render } from "./SupExSettlement.vue?vue&type=template&id=27b38303&scoped=true"
import script from "./SupExSettlement.vue?vue&type=script&lang=js"
export * from "./SupExSettlement.vue?vue&type=script&lang=js"

import "./SupExSettlement.vue?vue&type=style&index=0&id=27b38303&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b38303"]])

export default __exports__